import React from 'react'
import { motion } from "framer-motion"

const SkillBlock = ({ title, icons }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }} >

      <div className='my-3 '>
        <p className='mt-6 w-fit mx-auto text-xl sm:text-2xl mb-6 text-center border-b-2 border-gray-300'>{title}</p>
        <div className={`cursor-pointer w-full grid grid-cols-2 sm:grid-cols-4 gap-8 text-center  p-3  sm:px-6 rounded-xl`}>
          {
            icons.map(({ id, src, title }) => (
              <motion.div

                key={id}
                className={`flex flex-col justify-center items-center  shadow-md hover:scale-95 duration-500 py-2 rounded-lg `}
              >
                <motion.div
                  initial={{ opacity: 0, y: 20,scale:0.5}}
                  whileInView={{ opacity: 1, y: 0,scale:1}}
                  transition={{ duration: 0.7 }}
                  viewport={{ once: false }}
                  className=''
                >
                  <img
                    src={src} alt="img" className='sm:w-16 w-16  mx-auto m-2'
                  />
                </motion.div>
                <p className='flex justify-center items-center text-white py-2'>{title}</p>
              </motion.div>
            ))
          }
        </div>
      </div>
    </motion.div>
  )
}

export default SkillBlock   